'use client'
import { create } from 'zustand'

/**
 * Agent 会话页的跨页动作：
 * 首页创建会话后带首条消息跳转，对话页挂载时消费并发送。
 */
type PendingFirstMessage = {
  content: string
  skillId?: string
} | null

type AgentChatStore = {
  pendingFirstMessage: PendingFirstMessage
  setPendingFirstMessage: (payload: PendingFirstMessage) => void
  consumeFirstMessage: () => PendingFirstMessage
  /** 预填到聊天输入框的草稿（不自动发送）：画布节点/PPT 页"引用到对话"用 */
  pendingDraft: string | null
  setPendingDraft: (draft: string | null) => void
}

export const useAgentChatStore = create<AgentChatStore>((set, get) => ({
  pendingFirstMessage: null,
  setPendingFirstMessage: (payload) => set({ pendingFirstMessage: payload }),
  consumeFirstMessage: () => {
    const pending = get().pendingFirstMessage
    set({ pendingFirstMessage: null })
    return pending
  },
  pendingDraft: null,
  setPendingDraft: (draft) => set({ pendingDraft: draft }),
}))
